import AuthenticationContext from "components/Mighty/AuthenticationContext";
import { useContext } from "react";

function useCurrentUser() {
  return useContext(AuthenticationContext).currentUser;
}

export default useCurrentUser;
